import { toCamel } from 'snake-camel';

/**
 * Takes an object with `snake_case` keys and returns a new object with
 * `camelCase` keys. Values are unchanged.
 * @param jsonString JSON.stringify() encoded object.
 * @returns void or a new object with keys changed to camelCase.
 */
function snakeKeysToCamel(obj: Record<string, unknown>) {
  return toCamel(obj) as Record<string, unknown>;
}

export default snakeKeysToCamel;
